<ng-template #regionDisplay let-region="region" let-abbreviation="abbreviation">
    <ng-container [ngSwitch]="displayType">
        <ng-container *ngSwitchCase="regionValues.ABBREVIATION">{{abbreviation}}</ng-container>
        <ng-container *ngSwitchCase="regionValues.REGION">{{region}}</ng-container>
        <ng-container *ngSwitchDefault>{{region}} ({{abbreviation}})</ng-container>
    </ng-container>
</ng-template>

<ng-template #nativeSelect>
    <select [attr.aria-label]="'select state'" (ngModelChange)="writeValue($event);" [ngModel]="value"
            [tabindex]="tabindex" class="form-control"
            [disabled]="readonly"
            title="{{placeholder}}">

        <option [ngValue]="null">{{statesOnly ? 'State' : '-- Select --'}}</option>

        <optgroup *ngFor="let country of countries" label="{{country.country}}">
            <option *ngFor="let region of country.regions" [attr.aria-label]="region.region" [ngValue]="region" [selected]="region === value">
                <ng-container *ngTemplateOutlet="regionDisplay; context: { region: region.region, abbreviation: region.abbreviation }"></ng-container>
            </option>
        </optgroup>
    </select>
</ng-template>

<ng-container *ngIf="useMatSelect; else nativeSelect">
    <ng-container [formGroup]="formGroup">
        <mat-form-field appearance="outline" class="w-100">
            <mat-select placeholder="{{placeholder}}"
                        [formControlName]="controlName"
                        [compareWith]="statesOnly ? abbreviationsComparator : comparator"
                        [disabled]="disabled">
                <ng-template #regionSelector>
                    <mat-option [value]="null">{{'-- Select --'}}</mat-option>
                    <mat-optgroup *ngFor="let country of countries" label="{{country.country}}">
                        <mat-option *ngFor="let region of country.regions"
                                    [value]="valueType === regionValues.ABBREVIATION ? region.abbreviation : region">
                            <ng-container *ngTemplateOutlet="regionDisplay; context: { region: region.region, abbreviation: region.abbreviation }"></ng-container>
                        </mat-option>
                    </mat-optgroup>
                </ng-template>

                <ng-container *ngIf="statesOnly; else regionSelector">
                    <mat-option [value]="null">{{'State'}}</mat-option>
                    <mat-option *ngFor="let state of states"
                                [value]="state.abbreviation">
                        <ng-container *ngTemplateOutlet="regionDisplay; context: { region: state.region, abbreviation: state.abbreviation }"></ng-container>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </ng-container>
</ng-container>
